import { Controller } from '../utils/controller';
import {
  formUtilHideError,
  formUtilIsErrorDisplayed,
  formUtilValidateEmail
} from '../utils/accountFormUtils';

interface IFormTarget {
  inputContainer: HTMLElement;
  input: HTMLInputElement;
  error: HTMLInputElement;
}

interface IGuestActiveInputTargets {
  email: IFormTarget;
}

export default class extends Controller {
  readonly cssClass = {
    checkboxSelected: 'elc-checkbox-selected',
    checkboxNotSelected: 'elc-checkbox-not-selected',
    errorField: 'elc-floating-label-input-errorField',
    errorInputContainer: 'elc-floating-label-input-error'
  };

  static targets = [
    'guestCheckoutEmailContainer',
    'guestCheckoutEmailInput',
    'guestCheckoutEmailError'
  ];

  declare guestCheckoutEmailInputTarget: HTMLInputElement;
  declare guestCheckoutEmailErrorTarget: HTMLInputElement;
  declare guestCheckoutEmailContainerTarget: HTMLElement;

  getGuestActiveInputTargets(): IGuestActiveInputTargets {
    return {
      email: {
        input: this.guestCheckoutEmailInputTarget,
        error: this.guestCheckoutEmailErrorTarget,
        inputContainer: this.guestCheckoutEmailContainerTarget
      }
    };
  }

  validateGuestEmail(event: Event): void {
    const { email } = this.getGuestActiveInputTargets();

    formUtilValidateEmail(this, event, email);
  }

  isErrorDisplayed(target: HTMLElement): boolean {
    return formUtilIsErrorDisplayed(target);
  }

  showError(target: IFormTarget): void {
    const { error, input, inputContainer } = target;

    error.style.display = 'block';
    input.classList.add(this.cssClass.errorField);
    inputContainer.classList.add(this.cssClass.errorInputContainer);

    const {
      elc_account_errors: { password_required },
      elc_errors: { email_address_required, email_address_invalid }
    } = window.site.translations;

    if (input.type === 'password') {
      error.textContent = password_required;
    } else {
      error.textContent = input.value ? email_address_invalid : email_address_required;
    }
  }

  hideError(target: IFormTarget): void {
    const { error, input, inputContainer } = target;
    formUtilHideError(this, error, input, inputContainer);
  }

  submitGuestForm(event: Event): void {
    const { email } = this.getGuestActiveInputTargets();

    const hasErrors = this.isErrorDisplayed(email.error);
    const hasNoEmail = !email.input.value;

    if (hasNoEmail || hasErrors) {
      event.preventDefault();

      hasNoEmail && this.showError(email);
    } else {
      const submitButton = event.target as HTMLButtonElement;
      submitButton.disabled = true;
      submitButton.textContent = submitButton.getAttribute('data-disable-text');

      const form = submitButton.parentElement as HTMLFormElement;
      form.submit();
    }
  }
}
